import { SettingsService } from '@services/settings/settings.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  providers: [SettingsService]
})
export class FooterComponent implements OnInit {
  constructor(public settings: SettingsService) {}

  ngOnInit() {}
}
